export const TAB_IDENTIFIER = '.kmcc-tabs__item-control';



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/tab.config.js